import React from "react";
import "./Home1.css";
import img3 from "../images/img3.jpg";

const Home1 = () => {
  return (
    <div className="home1">
      <div className="contents">
        <div className="home1-content">
          <p>
            I'm Jack Saliba, a Lebanese paragliding pilot. Paragliding is not
            just a hobby; it's my passion. I take you flying in my paradise not
            only for business but to share smiles and to show you how beautiful
            Lebanon is from above.
          </p>
          <p>
            Trust me to demonstrate that paragliding is better than therapy; it
            dissipates all your stress and problems.
          </p>
        </div>
        <img className="image" src={img3} alt="" />
      </div>
    </div>
  );
};

export default Home1;
